<script setup>
import { ref } from 'vue'
import { Select } from '@components'
import useVisitor from '@stores/visitor'
const visitor = useVisitor()

const isLocked = 1 != wp_dark_mode_admin_json.is_ultimate

const select = ( ) => {

    if( isLocked && visitor.reportInterval > 1 ){
        visitor.reportInterval = 1
        window.WPDarkModePromo.show()
        return
    }

    visitor.updateChart()
}
</script>

<template>
    <div class="relative">
        <!-- main chart  -->
        <div class="flex justify-between items-center">
            <Heading>{{__('WP Dark Mode Usage', 'wp-dark-mode')}}</Heading>
            <div class="w-fit">
                <Select v-model="visitor.reportInterval" :options="visitor.reportIntervals" @select="select"></Select>
            </div>
        </div>
        <canvas ref="ctx" id="wp-dark-mode-chart" class="w-full max-w-xl mx-auto h-auto"></canvas>
    </div>
</template>
